import { Component, Input, OnDestroy, OnInit, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { DynReportService, Report9, ReportPeriod, ReportFilter, GroupCode } from '../shared';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { Message, TreeNode, SelectItem } from "primeng/primeng";

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'bp-dyn-report',
  templateUrl: './dyn-report9.component.html',
  styleUrls: ['./dyn-report9.component.css'],
})

export class DynReport9Component implements OnDestroy, OnInit, AfterViewInit {

  @Input() reportName: string;
  private dbResetSubscription: Subscription;
  private id: any;

  @ViewChildren('scroll') scroll: QueryList<any>;

  selectedRow: TreeNode;
  filter: ReportFilter;
  infos: Message[];
  report: Report9;
  //periodss: ReportPeriod[];
  selectedPeriod: ReportPeriod;
  groups: GroupCode[];
  selectedGroup: GroupCode = { value: "", text: "-" };
  selectedYear: SelectItem;

  budgetExeGraphData: any;
  budgetStructGraphData: any;
  top5expendituresGraphData: any;
  report9data: any;

  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private reportService: DynReportService,
    private toastService: ToastService) {
  }

  private getYears() {
    this.reportService.getReport9Years()
      .subscribe(filter => {
        this.filter = filter;
      });
  }

  private getPeriods() {
    this.reportService.getReport9Periods(this.selectedYear.value)
      .subscribe(filter => {
        if (this.filter) {
          this.filter.periods = filter.periods;
        } else {
          this.filter = filter;
        }
      });
  }

  private getReport(id: number, selectedGroup: string) {

    this.reportService.getReport9(id, selectedGroup)
      .subscribe(report => {
        this.report = report;

        this.budgetExeGraphData = this.reportService.buildBudgetExeGraphData9(this.report.graphData);
        this.budgetStructGraphData = this.reportService.buildBudgetStructGraphData9(this.report.graphData);
        this.top5expendituresGraphData = this.reportService.buildTop5expendituresGraphData9(this.report.topExpenditures);
      });
  }

  private gotoReports() {
    this.router.navigate(['/reports']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }

  ngOnInit() {

    //this.getPeriods();
    this.getYears();

    this.report9data = {
      labels: [],
      datasets: [
        {
          data: [] = [],
          backgroundColor: [] = []
        }]
    };
  }

  ngOnDestroy() {
    // this.dbResetSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.scroll.changes.subscribe((ellist: QueryList<any>) => {
      if (ellist.length > 0) {
        ellist.forEach((e, idx) => {
          if (!e.nativeElement['mcs']) {
            $(e.nativeElement).mCustomScrollbar("destroy");

            $(e.nativeElement).mCustomScrollbar({
              axis: "x",
              advanced: {
                updateOnContentResize: true
              },
              theme: "dark-thin",
              scrollButtons: {
                enable: true
              },
            });
          }
        });
      }

    });
  }

  nodeSelect(event) {
    //console.log('event', event);
   // this.infos = [];
   // this.infos.push({ severity: 'info', summary: 'Node Selected', detail: event.node.data.name });
    if (event.node && event.node.children && event.node.children.length > 0) {
      if (event.node.expanded == false)
        event.node.expanded = true;
      else
        event.node.expanded = false;
    }
     
  }

  nodeUnselect(event) {
   // this.infos = [];
   // this.infos.push({ severity: 'info', summary: 'Node Unselected', detail: event.node.data.name });
    if (event.node && event.node.children && event.node.children.length > 0) {
      event.node.expanded = false;
    }
  }

  showReport(event: Event) {
    this.getReport(this.selectedPeriod.id, this.selectedGroup.value);
  }


  periodChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.groups = this.selectedPeriod.groups;
    //console.log('selectedGroup', this.selectedGroup);
  }
  reportYearChanged(event: Event) {
    this.selectedGroup = { value: "", text: '-' };
    this.selectedPeriod = null;
    this.getPeriods();

  }

}



// WEBPACK FOOTER //
// ./src/app/dyn-reports/dyn-report/dyn-report9.component.ts